import type { ModelResult } from '~/features/x-ray/types/model';

import { sylvanus } from '~/services/serviceInstances';
import { Nullable } from '~/types/Nullable';

import { PagePromptModel, PromptModelStatus } from '../../types/sylvanus/model';
import { mapModelResult } from './transformers';

interface Request {
  pageIndex: number;
  pageSize: number;
  //TODO: Remove this once the API type is updated
  status: Nullable<PromptModelStatus | 'republished'>;
  sortBy?: {
    id: string;
    desc: boolean;
  };
}

interface Response {
  results: ModelResult[];
  totalCount: number;
}

export const getPromptModelResults = async ({
  pageIndex,
  pageSize,
  status,
  sortBy,
}: Request): Promise<Response> => {
  const response: PagePromptModel = await sylvanus.get('/model', {
    params: {
      include_latest_version: true,
      page: pageIndex,
      size: pageSize,
      status,
      sort_by: sortBy?.id || undefined,
      reverse: sortBy?.id ? sortBy.desc : undefined,
    },
  });

  return {
    results: response.items.map(mapModelResult()),
    totalCount: response.total ?? 0,
  };
};
